<template>
    <div class="block-editor ideasoft-product-search">
        <section v-if="!channel">
            <a-result status="warning" title="Ideasoft API not connected">
                <template #extra>
                    <div class="d-flex align-items-center justify-content-center">
                        <SupsisButton primary ghost @click="gotoIdeasoft"> Connect to Ideasoft</SupsisButton>
                    </div>
                </template>
            </a-result>
        </section>
        <template v-else>
            <section class="active-connection">
                <div data-small="true" class="logos">
                    <div class="logo1">
                        <img class="custom-block-logo" src="/static/img/supsis-logo2.png" />
                    </div>
                    <span class="material-icons"> add </span>
                    <div class="logo2">
                        <img class="" src="/static/img/ideasoft.webp" />
                    </div>
                </div>
                <div class="active-connection-text">
                    <div><span>Connected with</span> <b>Ideasoft</b></div>
                </div>
            </section>
            <div class="ideasoft-product-search-wrapper">
                <div class="inputTitle">Ürün Arama Terimi</div>
                <div class="text-editor-wrapper">
                    <TiptapEditor
                        v-model="clone.searchTerm"
                        :show-attributes="true"
                        :max-character-count="100"
                        :show-emoji="false"
                        placeholder="Ürün adı veya stok kodu"
                        :rows="1"
                    />
                </div>
                <div class="helper-text">
                    <div class="text-muted">
                        <i class="fas fa-info-circle"></i>
                        Bu blok önce ürün adına göre arama yapar, sonuç bulamazsa stok koduna göre arama yapar.
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import log2 from "../../../../../../../utils/log2";
import TiptapEditor from "../../common/TiptapEditor";
import AttributeLabel from "../../common/tiptap-extensions/AttributeLabel";
import AttributeIconPreview from "../../common/AttributeIconPreview";

import _ from "lodash";
import { mapState } from "vuex";
import SupsisButton from "../../../../../Settings/components/SupsisButton.vue";

const log = log2("IdeasoftProductSearch");
export default {
    name: "IdeasoftProductSearch",
    components: { SupsisButton, TiptapEditor, AttributeLabel, AttributeIconPreview },
    props: {
        value: {
            type: Object,
            default: () => ({ searchTerm: "{{product_name}}" }),
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            nextStepFilledValue: [
                "product_name",
                "product_sku",
                "product_price",
                "product_stock",
                "product_status",
                "product_brand",
                "product_categories"
            ],
        };
    },
    computed: {
        ...mapState({
            channel: (state) => state.channel.channels.find((x) => x.type === "ideasoft"),
        }),
    },
    methods: {
        gotoIdeasoft() {
            this.$router.push("/integrations/ideasoft");
        },
    },
    mounted() {
        log("mounted");
    },
    watch: {
        clone: {
            handler(val) {
                log("clone changed", val);
                this.$emit("input", val);
            },
            deep: true,
        },
        value(val) {
            if (_.isEqual(val, this.clone)) {
                return;
            }
            this.clone = _.cloneDeep(val);
        },
    },
};
</script>

<style lang="scss">
.block-editor.ideasoft-product-search {
    padding: 30px 30px 0;

    .active-connection {
        align-items: center;
        background: #fff;
        border-radius: 6px;
        display: flex;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 20px;
        overflow: hidden;
        padding: 20px;
        width: 100%;
        word-break: break-word;

        .logos {
            align-items: center;
            display: flex;
            flex-shrink: 0;
            margin-right: 15px;
            margin-top: 4px;

            .logo1 {
                background: #4a6586;
            }

            .logo2 {
                background: #fff;
            }

            .logo1,
            .logo2 {
                height: 30px;
                padding: 4px;
                width: 30px;
            }
        }

        .filled-attributes {
            margin: 0px 0px -17px -50px !important;
        }
    }

    .next-step-filled-items-wrapper {
        background: #fff;
        border-radius: 6px;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 20px;
        padding: 20px;
        width: 100%;

        .middle-section {
            background: #f30879;
            color: white;
            cursor: pointer;
            transition: all 0.3s;
            border-radius: 10px;
            box-decoration-break: clone;
            display: flex;
            justify-content: center;
            padding: 5px;
            width: fit-content;
            margin: 5px;
            align-items: center;
            font-weight: 800;

            &:hover {
                transform: translateY(-1px);
                box-shadow: 0 2px 8px rgba(243, 8, 121, 0.3);
            }
        }
    }

    .active-connection-text {
        flex-grow: 1;
        flex-shrink: 0;
        width: 0;

        div {
            overflow: hidden !important;
            text-overflow: ellipsis;
            white-space: pre-wrap;
        }
    }

    .ideasoft-product-search-wrapper {
        .inputTitle {
            margin-bottom: 10px;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .helper-text {
            margin-top: 8px;

            .text-muted {
                color: #6c757d !important;
                font-size: 12px;

                .fas {
                    margin-right: 6px;
                    color: #17a2b8;
                }
            }
        }

        .editable-editor {
            p {
                margin-bottom: 0;
            }
        }
    }
}
</style>

